module.exports = __webpack_public_path__ + "static/media/compensar3.ddf8de34.svg";